<script lang="ts" setup>
interface Props {
  noGutter?: boolean;
  fitParent?: boolean;
  fill?: boolean;
  /** Caps the body at the header's width (`max-w-7xl`) instead of the reading-width ramp. */
  wide?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  noGutter: false,
  fitParent: false,
  fill: false,
  wide: false,
});

const rootClasses = computed(() =>
  twMerge(
    cva('w-full scrollbar-hidden flex flex-col', {
      variants: {
        fill: {
          true: 'flex-1 min-h-0',
          false: 'h-full',
        },
      },
    })({ fill: props.fill }),
  ),
);

const bodyClasses = computed(() =>
  twMerge(
    cva('w-full mx-auto flex-1', {
      variants: {
        wide: {
          true: 'max-w-7xl',
          false: 'sm:max-w-4xl lg:max-w-5xl',
        },
        noGutter: {
          true: '',
          false: 'px-4',
        },
        fitParent: {
          true: 'min-h-0',
          false: '',
        },
        fill: {
          true: 'flex flex-col min-h-0 rounded-t-3xl md:rounded-none',
          false: '',
        },
      },
    })({
      wide: props.wide,
      noGutter: props.noGutter,
      fitParent: props.fitParent,
      fill: props.fill,
    }),
  ),
);
</script>

<template>
  <div :class="rootClasses">
    <div
      v-if="$slots.header"
      class="mb-10 w-full max-w-7xl mx-auto"
      :class="{ 'px-4': !noGutter }"
    >
      <!-- wide header/banner -->
      <slot name="header" />
    </div>
    <div :class="bodyClasses">
      <slot />
    </div>
    <div v-if="$slots.footer" class="mt-10">
      <!-- full width footer -->
      <slot name="footer" />
    </div>
  </div>
</template>
